import { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from "@mui/material/Backdrop";
import { useTheme } from "@mui/material";

export default function Loading(props: any) {
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        window.addEventListener("LOADING", eventHandler);
    }, []);

    const eventHandler = (e: any) => {
        setLoading(e.detail)
    }

    return (
        <Backdrop sx={{ zIndex: useTheme().zIndex.drawer + 1000 }} open={loading}>
            <CircularProgress size={94} />
        </Backdrop>
    );
}
